export default "__VITE_ASSET__2336d066__"